import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=0b367eac&scoped=true"
import script from "./ProfileTab.vue?vue&type=script&lang=js"
export * from "./ProfileTab.vue?vue&type=script&lang=js"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&id=0b367eac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b367eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b367eac')) {
      api.createRecord('0b367eac', component.options)
    } else {
      api.reload('0b367eac', component.options)
    }
    module.hot.accept("./ProfileTab.vue?vue&type=template&id=0b367eac&scoped=true", function () {
      api.rerender('0b367eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/ProfileTab.vue"
export default component.exports